import angular from 'angular';

const userMessagesServices = angular.module('applicationModule.userMessagesServices', []);

userMessagesServices.factory('Messages', ['MessagesAPI', function (MessagesAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return MessagesAPI.getMessages(appId, params)
                .then(function (response) {
                    return response.data.message;
                });
        },
        getListQueue: function (appId, params) {
            return MessagesAPI.getListQueue(appId, params)
                .then(function (response) {
                    return response.data.message;
                });
        },
        remove: function (Id) {
            return MessagesAPI.removePush(Id);
        }
    };
}]);


userMessagesServices.service('MessagesAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const MESSAGE_URL = AppsoupAPI.API_URL + '/app/messages/';

    this.getMessages = function (appId, params) {
        return $http.get(MESSAGE_URL + 'index', {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.sendMessage = function (input, phone, options) {
        var phone_system = {phone_system: phone};

        return $http.post(MESSAGE_URL + 'send', {message: input, filter: phone_system, options: options});
    };

    this.getListQueue = function (appId, params) {
        return $http.get(MESSAGE_URL + 'indexQueue', {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.removePush = function (Id) {
        return $http.delete(MESSAGE_URL + 'delete/' + Id);
    };
}]);

export default userMessagesServices;
